<template>
    <div class="p-8">
      <v-progress-linear v-if="loading" color="secondary" height="6" indeterminate rounded></v-progress-linear>

        <v-card
          class="pa-4 mt-4"
          v-if="listOr"
        >
         
            <v-card-title>
              Lista de OCs
            </v-card-title>

            <v-card-subtitle>
              Lista de OCs - 30 Dias.
            </v-card-subtitle>

          <v-card-text class="bg-surface-light pt-4">
            <v-row class="mb-4" align="center" justify="space-between">
              <v-col cols="auto" class="d-flex justify-end">
              </v-col>
                <v-col cols="auto">
                  <input
                    type="file"
                    ref="fileImport"
                    id="fileImport"
                    accept=".xlsx"
                    style="display: none"
                    @change="importarExcelOrdenes"
                  />

              <div v-if="this.proveedores.length > 0" class="d-flex align-center button-group">
                <v-btn
                  color="primary"
                  outlined
                  :disabled="templateProgress"
                  :loading="templateProgress"
                  @click="descargarTemplateImportacion"
                >
                  <v-icon left>mdi-download</v-icon>
                  Plantilla TP
                </v-btn>

                <v-btn
                  color="primary"
                  dark
                  :disabled="templateProgress || importProgress"
                  @click="$refs.fileImport.click()"
                >
                  <v-icon left>mdi-file-import</v-icon>
                  Importar
                </v-btn>

                <v-btn
                  color="primary"
                  dark
                  :disabled="templateProgress || importProgress"
                  @click="exportarExcelOrdenes"
                >
                  <v-icon left>mdi-file-excel</v-icon>
                  Exportar
                </v-btn>
              </div>

              </v-col>
            </v-row>
            <v-alert
              v-if="importResultVisible"
              :type="importResultType"
              border="left"
              prominent
              dismissible
              class="mb-4"
              @input="importResultVisible = false"
            >
              <div class="font-weight-bold">{{ importResultTitle }}</div>
              <div>{{ importResultMessage }}</div>
            </v-alert>
            <!-- Filtros -->
            <v-row class="mb-4" dense>
              <v-col v-for="column in headers" :key="column.value" v-if="column.value !== 'action'" cols="2">
                <v-text-field
                v-model="filters[column.value]"
                :label="'Filtrar ' + column.title"
                dense
                hide-details
                outlined
                />
              </v-col>
              </v-row>
              <v-data-table
              :headers="headers"
              :items="filteredItems"
              item-key="RequestProposal_id"
              show-expand
              class="elevation-1"
            >
              <template v-slot:item.RepOrderStatus_id="{ item }">
                <v-chip
                  v-if="getRepOrderStatus(item.RepOrderStatus_id).RepOrderStatus_Color"
                  :color="getRepOrderStatus(item.RepOrderStatus_id).RepOrderStatus_Color"
                  :border="`${getRepOrderStatus(item.RepOrderStatus_id).RepOrderStatus_Color} thin opacity-10`"
                  size="small"
                >
                  {{ getRepOrderStatus(item.RepOrderStatus_id).RepOrderStatus_Desc }}
                </v-chip>
              </template>
              <template v-slot:item.ServiceLevel_Pct="{ item }">
                {{ item.ServiceLevel_Pct }}%
              </template>
              <!-- Fila expandida -->
              <template v-slot:item.fechaHoraAct="{ item }">
                {{ item.OC_Update_Dt }} {{ item.OC_Update_Tm }}
              </template>
              <template v-slot:item.action="{ item }">
                <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    class="mr-2"
                    v-bind="attrs"
                    v-on="on"
                    @click="GetRepOrder(item)"
                  >
                    mdi-eye
                  </v-icon><!--editOrder(item)-->
                  </template>
                  <span>Ver Detalle</span>
                  </v-tooltip>
                  <!-- <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    class="mr-2"
                    v-bind="attrs"
                    v-on="on"
                    v-if="item.RepOrderStatus_id !== 5"
                    @click="onCancel(item)"
                  >
                    mdi-checkbox-marked-outline
                  </v-icon>
                  </template>
                  <span>Finalizar</span>
                  </v-tooltip> -->
                </template>
                <template v-slot:expanded-item="{ headers, item }">
                          <td :colspan="headers.length">
                            <v-expand-transition>
                              <div v-if="item.RepOrderStatus_id > 0">
                                <v-card class="pa-4 mt-2" elevation="2" color="#FAFAFA">
                                  <v-form>
                                    <v-autocomplete v-model="RepOrderPenalityReason.RepOrderPenalityReason_id"
                                    :items="RepOrderPenalityReason"
                                    :item-text="'RepOrderPenalityReason_Desc'"
                                    :item-value="'RepOrderPenalityReason_id'"
                                    label="Motivo"
                                    outlined
                                    required
                                    :rules="[v => !!v || 'Este campo es requerido']"
                                    @change="updateDescription"
                                    ></v-autocomplete>
                                  <v-textarea
                                    v-model="respuesta"
                                    label="Escribe tu respuesta"
                                    outlined
                                    auto-grow
                                    rows="2"
                                  />
                                  <v-col cols="6">
                                  <v-file-input v-model="files2"
                                      outlined
                                      accept=".xlsx"
                                      label="Archivo excel"
                                      placeholder="Seleccione su archivo"
                                      name="file2"  
                                      id="file2"
                                      required
                                      :rules="[v => !!v || 'Archivo requerido']"></v-file-input>
                                </v-col>
                                  <div class="text-right mt-2">
                                    <v-btn
                                      color="success"
                                      :loading="loading"
                                      @click="() => enviarRespuesta(item.Supplier_id,item)"
                                      small
                                    >
                                      <v-icon left>mdi-send</v-icon>
                                      Enviar
                                    </v-btn>
                                  </div>
                                  </v-form>
                                </v-card>
                              </div>
                            </v-expand-transition>
                          </td>
                        </template>
            </v-data-table>
              <!-- <v-data-table
              :headers="headers"
              :items="filteredItems"
              item-value="name"
              class="elevation-1"
              >
              <template #item="{ item }">
                <tr>
                  <td>{{ item.RepGroup_id }}</td>
                  <td>{{ item.EffectiveDate }}</td>
                  <td>{{ item.ExpirationDate }}</td>
                  <td>{{ item.LastOpRepUser_id }}</td>
                  <td>{{ item.RepEvent_Dt }}</td>
                  <td>{{ item.RepEvent_Tm }}</td>
                </tr>
              </template>
            </v-data-table>  -->
            <!-- Botón de exportación -->

          </v-card-text>
        </v-card>

        <!-- <v-textarea
                          v-model="OrdenItem.RepOrder_Text"
                          label="Contenido"
                          auto-grow
                          outlined
                        />  -->
        <!-- <v-autocomplete v-model="ReceiversItem.MotherSupplier_id"
          :items="proveedores"
          :item-text="'MotherSupplier_Desc'"
          :item-value="'MotherSupplier_id'"
          label="Proveedores"
          multiple
          outlined
          chips
          @change="agregarProducto"
          ></v-autocomplete>

          <v-data-table
            :items="itemsEnTabla"
            :headers="headers"
            class="mt-4"
          ></v-data-table> -->

      <v-dialog v-model="dialog_new" max-width="900px">
      <v-stepper v-model="e1" vertical>
            <p align="right"><v-btn color="blue darken-1" text @click="close">X</v-btn></p>
            <v-stepper-step :complete="e1 > 1" step="1" :rules="[value => !! step_error1]" :color="step_color1">Generando Comunicación
                <small>Generando Comunicación: {{this.OrdenItem.RepOrder_id}} - {{ this.OrdenItem.RepOrder_Desc }}</small>
            </v-stepper-step>
            <v-stepper-content step="1">
            <v-card height="100px">
                <div class="text-center">
                <v-progress-circular v-if="progressBar1" indeterminate size="64" color="primary"></v-progress-circular><br>
                {{this.msj_proceso}}
                </div>
            </v-card>
            </v-stepper-content>
    
            <v-stepper-step :complete="e1 > 2" step="2" :rules="[value => !! step_error2]" :color="step_color2">Registrando Destinatarios
                <small>Asignando datos con el destinatario</small>
            </v-stepper-step>
            <v-stepper-content step="2">
            <v-card height="100px">
                <div class="text-center">
                <v-progress-circular v-if="progressBar1" indeterminate size="64" color="primary"></v-progress-circular><br>
                {{this.msj_proceso}}
                </div>
            </v-card>
            </v-stepper-content>

            <v-stepper-step :complete="e1 > 3" step="3" :rules="[value => !! step_error3]" :color="step_color3">Finalizando Comunicación
                <small>Validando la Comunicación creada </small>
            </v-stepper-step>
            <v-stepper-content step="3">
            <v-card height="100px">
                <div class="text-center">
                <v-progress-circular v-if="progressBar1" indeterminate size="64" color="primary"></v-progress-circular><br>
                <pre>{{this.msj_proceso}}</pre>
                </div>
            </v-card>
            </v-stepper-content>
            
        </v-stepper>
      </v-dialog>
      <v-dialog v-model="viewrepo" max-width="900px">
        <v-overlay :value="overlay_de">
            <v-progress-circular indeterminate size="64" color="accent"></v-progress-circular>
        </v-overlay>
        <v-card>
          <v-card-title class="d-flex justify-space-between align-center">
          <span>Detalle de Orden</span>
          <v-btn icon @click="viewrepo = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>
        <v-card-text>
        <v-stepper v-model="e2" class="mb-10">
                    <v-stepper-header>

                        <v-stepper-step step="1" :complete="e2 == 2">Pendiente</v-stepper-step>

                        <v-divider></v-divider>

                        <v-stepper-step step="2" :complete="e2 == 7">No Entregado</v-stepper-step>
                        <v-divider></v-divider>

                        <v-stepper-step step="3" :complete="e2 == 8">Entrega Parcial</v-stepper-step>
                        <v-divider></v-divider>

                        <v-stepper-step step="4" :complete="e2 == 9">Recibido</v-stepper-step>
                    </v-stepper-header>
                </v-stepper>

                <v-divider />
                <v-form ref="form">
                    <v-card variant="flat">
                      <v-card-subtitle class="f-w-800">Orden</v-card-subtitle>
                        <v-card-text>
                          <v-row>
                            <v-col cols="2">
                              <v-text-field
                                label="Punto"
                                v-model="RepOrder2.OpPoint_id"
                                outlined
                                readonly
                              ></v-text-field>
                            </v-col>
                            <v-col cols="2">
                              <v-text-field
                                  label="Orden Id"
                                  v-model="RepOrder2.VendorPurchaseOrder_Num"
                                  placeholder="1"
                                  outlined
                                  readonly
                                ></v-text-field>
                            </v-col>
                            <v-col cols="5">
                              <v-text-field
                                label="Proveedor"
                                v-model="RepOrder2.Supplier_Description"
                                placeholder="Descripción"
                                outlined
                                readonly
                                :rules="[v => !!v || 'Descripción requerida']"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="3">
                              <v-text-field
                                label="Estado"
                                v-model="RepOrder2.RequestProposalStatus_Desc"
                                placeholder="9999-12-31"
                                outlined
                                readonly
                              ></v-text-field>
                            </v-col>
                            </v-row>
                            <v-row>
                            <v-col cols="3">
                              <v-text-field
                                label="Tipo Pedido"
                                v-model="RepOrder2.RequestProposalSrc_Desc"
                                placeholder="9999-12-31"
                                outlined
                                readonly
                              ></v-text-field>
                            </v-col>
                            <v-col cols="2">
                              <v-text-field
                                label="Fecha Emisión"
                                v-model="RepOrder2.RequestProposal_Dt"
                                placeholder="9999-12-31"
                                outlined
                                readonly
                              ></v-text-field>
                            </v-col>
                            <v-col cols="3">
                              <v-text-field
                                label="Fecha de Entrega"
                                v-model="RepOrder2.Reception_Dt"
                                placeholder="9999-12-31"
                                outlined
                                readonly
                              ></v-text-field>
                            </v-col>
                            <v-col cols="2">
                              <v-text-field
                                label="Fecha de Cierre"
                                v-model="RepOrder2.Closing_Dt"
                                placeholder="9999-12-31"
                                outlined
                                readonly
                              ></v-text-field>
                            </v-col>
                            <v-col cols="2">
                              <v-text-field
                                label="Id RFM"
                                v-model="RepOrder2.RequestProposal_id"
                                placeholder="9999-12-31"
                                outlined
                                readonly
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-card-text>
                    </v-card>
                    <v-divider class="my-5" />

                    <v-card variant="flat">
                        <v-card-subtitle class="f-w-800">Detalle</v-card-subtitle>
                        <v-card-text>
                        <v-sheet rounded="0" border>
                          <v-data-table
                          :headers="headers4"
                          :items="subitems2"
                          item-key="RequestProposalLine_id"
                          class="elevation-1"
                          show-expand
                          header-class="custom-header"
                        >
                        <template v-slot:item.RepOrderItemsStatus_id="{ item }">
                          <v-chip
                            v-if="getRepOrderItemsStatus(item.RepOrderItemsStatus_id).RepOrderItemsStatus_Color"
                            :color="getRepOrderItemsStatus(item.RepOrderItemsStatus_id).RepOrderItemsStatus_Color"
                            :border="`${getRepOrderItemsStatus(item.RepOrderItemsStatus_id).RepOrderItemsStatus_Color} thin opacity-10`"
                            size="small"
                          >
                            {{ getRepOrderItemsStatus(item.RepOrderItemsStatus_id).RepOrderItemsStatus_Desc }}
                          </v-chip>
                        </template>
                        
                        <template v-slot:expanded-item="{ headers, item }">
                          <td :colspan="headers.length">
                            <v-expand-transition>
                              <div v-if="item.RepOrderItemsStatus_id > 2">
                                <v-card class="pa-4 mt-2" elevation="2" color="#FAFAFA">
                                  <v-form>
                                    <v-autocomplete v-model="RepOrderPenalityReason.RepOrderPenalityReason_id"
                                    :items="RepOrderPenalityReason"
                                    :item-text="'RepOrderPenalityReason_Desc'"
                                    :item-value="'RepOrderPenalityReason_id'"
                                    label="Motivo"
                                    outlined
                                    required
                                    :rules="[v => !!v || 'Este campo es requerido']"
                                    ></v-autocomplete>
                                  <v-textarea
                                    v-model="respuesta"
                                    label="Escribe tu respuesta"
                                    outlined
                                    auto-grow
                                    rows="2"
                                  />
                                  <v-col cols="6">
                                  <v-file-input v-model="files2"
                                      outlined
                                      accept=".xlsx"
                                      label="Archivo excel"
                                      placeholder="Seleccione su archivo"
                                      name="file2"  
                                      id="file2"
                                      required
                                      :rules="[v => !!v || 'Archivo requerido']"></v-file-input>
                                </v-col>
                                  <div class="text-right mt-2">
                                    <v-btn
                                      color="success"
                                      :loading="loading"
                                      @click="() => enviarRespuesta(item.Supplier_id,RepOrder2)"
                                      small
                                    >
                                      <v-icon left>mdi-send</v-icon>
                                      Enviar
                                    </v-btn>
                                  </div>
                                  </v-form>
                                </v-card>
                              </div>
                            </v-expand-transition>
                          </td>
                        </template>
                        
                        </v-data-table>
                        </v-sheet>
                        </v-card-text>
                    </v-card>
                    <v-divider class="my-5" />
                    <v-card variant="flat">
                        <v-card-subtitle class="f-w-800">Movimientos</v-card-subtitle>
                        <v-card-text>
                      <v-sheet rounded="" border>
                        <v-data-table
                          :headers="headers5"
                          :items="RepOrderItemsPenality"
                          class="elevation-1"
                          header-class="custom-header"
                        ><template v-slot:item.fechaHoraAct2="{ item }">
                          {{ item.RepEvent_Dt }} {{ item.RepEvent_Tm }}
                        </template>
                      </v-data-table>
                    </v-sheet>
                    </v-card-text>
                    </v-card>

                    <v-divider class="my-5" />

                    <v-row justify="end">
                        <v-col cols="6" lg="2" md="6" sm="12" justify="end" class="">
                            <div class="d-flex ga-6 mt-8 justify-end">
                                <!--<v-btn color="secondary" variant="flat" @click="volver">Regresar</v-btn>-->
                            </div>
                        </v-col>
                        <v-col cols="6" lg="2" md="6" sm="12" justify="end" class="">
                            <div class="d-flex ga-6 mt-8 justify-end">
                                <v-btn @click="onCancel(RepOrder2)" v-if="e2 < 5" color="primary" variant="outlined">Finalizar</v-btn>
                            </div>
                        </v-col>
                    </v-row>
                </v-form>
        <!--<RepOrderView :id="this.RepOrder.RepOrder_id"/>-->
        </v-card-text>
        </v-card>
      </v-dialog>
      <v-overlay :value="progressBar">
        <v-progress-circular indeterminate size="64" color="accent"></v-progress-circular>
      </v-overlay>

      <v-overlay :value="templateProgress" opacity="0.65">
        <v-card width="600" class="pa-6">
          <div class="text-center mb-4">
            <v-icon color="primary" size="40">mdi-file-download</v-icon>
          </div>
          <div class="text-center font-weight-medium mb-4">{{ templateMessage }}</div>
          <v-progress-linear
            color="primary"
            height="10"
            indeterminate
            rounded
          ></v-progress-linear>
          <div class="text-center mt-3 text-caption">
            Por favor aguarde. La descarga está en curso.
          </div>
        </v-card>
      </v-overlay>

      <v-overlay :value="importProgress" opacity="0.65">
        <v-card width="600" class="pa-6">
          <div class="text-center mb-4">
            <v-icon color="primary" size="40">mdi-file-excel</v-icon>
          </div>
          <div class="text-center font-weight-medium mb-4">{{ importMessage }}</div>
          <v-progress-linear
            v-if="!importProgressComplete"
            color="primary"
            height="10"
            indeterminate
            rounded
          ></v-progress-linear>
          <v-progress-linear
            v-else
            color="success"
            height="10"
            :value="100"
            rounded
          ></v-progress-linear>
          <div class="text-center mt-3 text-caption">
            Por favor aguarde. No cierre esta ventana.
          </div>
        </v-card>
      </v-overlay>
    </div>
  </template>
  
  <script>
  //import XLSX from 'xlsx-style'
  import * as XLSX2 from 'xlsx'
  import { saveAs } from 'file-saver'
  import axios from 'axios'
  import { EventBus } from '@/event-bus'
  import router from '@/router'
  import RepOrderView from './RepOrderView'
  export default {
    data: () => ({
      search: '',
      newcmp: false,
      e1: 0,
      e2: 0,
      msj_proceso:'',
      ApiUserSupplier:[],
      progressBar1: false,
      overlay: false,
      step_error1: true,
      step_error2: true,
      step_error3: true,
      step_color1:"primary",
      step_color2:"primary",
      step_color3:"primary",
      listOr: true,
      dialog_new: false,
      btnG: true,
      valid: true,
      valid2: true,
      dialog: false,
      loading2: false,
      viewrepo: false,
      filters: {},
      api_tool_url: process.env.VUE_APP_API_TOOL_URL,
      tabs: 0,
      text: 'Lorem ipsum',
      NombreHoja1: '',
      NombreHoja2: '',

      loading: false,
      taberror: false,
      progressBar: false,
      templateProgress: false,
      templateMessage: 'Generando Plantilla TP...',
      importProgress: false,
      importProgressComplete: false,
      importMessage: 'Procesando archivo...',
      importResultVisible: false,
      importResultType: 'success',
      importResultTitle: '',
      importResultMessage: '',

      mostrarTabs: false,
      overlay_de: false,
      items: [
        {
          icon: 'mdi-account-box',
          text: 'Destinatarios'
        },       
        {
          icon: 'mdi-file-document',
          text: 'Mail'
        },
        {
          icon: 'mdi-alert-circle',
          text: 'Errores'
        }
      ],
      headers: [
        { text: 'Pedido_Id', title: 'Pedido_Id', value: 'RequestProposal_id', align: 'center', sortable: true, key: 'RequestProposal_id' },
        { text: 'OC', title: 'OC', value: 'VendorPurchaseOrder_Num', align: 'center', sortable: true, key: 'VendorPurchaseOrder_Num' },
        { text: 'Proveedor', title: 'Proveedor', value: 'Supplier_Description', align: 'center', sortable: true, key: 'Supplier_Description' },
        { text: 'Estado', title: 'Estado', value: 'RepOrderStatus_id', align: 'center', sortable: true, key: 'RepOrderStatus_id' },
        { text: 'NS', title: 'NS', value: 'ServiceLevel_Pct', align: 'center', sortable: true, key: 'ServiceLevel_Pct' },
        { text: 'Ultima TP', title: 'Ultima TP', value: 'RepOrderPenalityReason_Desc', align: 'center', sortable: true, key: 'RepOrderPenalityReason_Desc' },
        { text: 'Fecha Act', title: 'Fecha Act', value: 'fechaHoraAct', align: 'center', sortable: true, key: 'fechaHoraAct' },
        { text: 'Acción', value: 'action'}
      ],
      headers1:[
        { text: 'Agregar', key: 'selected',value: 'selected',sortable: false },
        { text: 'Id Usuario', key: 'ApiUser_id',value: 'ApiUser_id' },
        { text: 'Nombre', key: 'ApiUser_GivenName',value: 'ApiUser_GivenName' },
        { text: 'Email', key: 'ApiUser_EMail',value: 'ApiUser_EMail' },
        { text: 'Folio', key: 'ApiUser_Supplier',value: 'ApiUser_Supplier' },
        { text: 'Desc Proveedor', key: 'MotherSupplier_Desc',value: 'MotherSupplier_Desc' }
      ],
      headers2:[],
      headers3:[
        { text: 'Linea', key: 'Line',value: 'Line' },
        { text: 'Solapa', key: 'Solapa',value: 'Solapa' },
        { text: 'Error', key: 'Error',value: 'Error' }
      ],
      headers4:[
        { text: 'N°', key: 'RequestProposalLine_id',value: 'RequestProposalLine_id' },
        { text: 'EAN Id', key: 'ProductBarCode_id',value: 'ProductBarCode_id' },
        { text: 'EAN Desc', key: 'Product_LongDescription',value: 'Product_LongDescription' },
        { text: 'Pedido', key: '_OC_Purchase_Qty',value: '_OC_Purchase_Qty' },
        { text: 'Recibido', key: '_OC_Received_Qty',value: '_OC_Received_Qty' },
        { text: 'Estado', key: 'RepOrderItemsStatus_id',value: 'RepOrderItemsStatus_id' },
        { text: 'NS', key: 'ServiceLevel_Pct',value: 'ServiceLevel_Pct' }
      ],
      headers5:[
        { text: 'N°', key: 'RepOrderItemsPenality_id',value: 'RepOrderItemsPenality_id' },
        { text: 'Motivo', key: 'RepOrderPenalityReason_Desc',value: 'RepOrderPenalityReason_Desc' },
        { text: 'Descripción', key: 'RepOrderItemsPenality_Desc',value: 'RepOrderItemsPenality_Desc' },
        { text: 'Observación', key: 'RepOrderItemsPenality_Obs',value: 'RepOrderItemsPenality_Obs' },
        { text: 'Usuario', key: 'LastOpRepUser_id',value: 'LastOpRepUser_id' },
        { text: 'Fecha Act', title: 'Fecha Act', value: 'fechaHoraAct2', align: 'center', sortable: true, key: 'fechaHoraAct2' },
      ],
      headers6:[],
      ordenes: [
        { orden_id: 101, descripcion: 'Compra materiales A', estado: 'Pendiente' },
        { orden_id: 102, descripcion: 'Compra materiales B', estado: 'Completado' }
      ],
      subitems: [],
      subitems2: [],
      orderStore:[],
      RepOrderItems:[],
      RepOrderItemsPenality:[],
      itemsEnTabla:[],
      proveedores: [],
      RepOrderTemplate: [],
      RepOrder:[],
      RepOrder2:[],
      oppoint2: [],
      selectedDescription: '',
      destinatarios:[],
      data2:[],
      data3:[],
      errores: [],
      respuesta: '',
      token: sessionStorage.getItem('access_token'),
      user: sessionStorage.getItem('ApiUser_id'),
      hora: '',
      fechaHoy: new Date().toISOString().split('T')[0],
      editedIndex: -1,
      RepOrderPenalityReason: {
        RepOrderPenalityReason_id: -1,
        RepOrderPenalityReason_Desc: 'No Informado.'
      },
      RepOrderTemplate2: {
        RepOrderTemplate2_id: 0
      },
      serverItems:[],
      filters: {
        RepGroup_id: '',
        EffectiveDate: '',
        ExpirationDate: '',
        LastOpRepUser_id: '',
        RepEvent_Dt: '',
        RepEvent_Tm: ''
      },
      files:[],
      files2:[],
      OrdenItem: {
        RepOrder_id: '',
        RepOrder_Desc: '',
        RepOrder_Text: '',
        RepOrderStatus_id: '1',
        CreationRepEvent_id: this.token,
        CreationRepUser_id: this.user,
        CreationRepEvent_Dt: this.fechaHoy,
        CreationRepEvent_Tm: '',
        RepEvent_id: this.token,
        LastOpRepUser_id: this.user,
        RepEvent_Dt: this.fechaHoy,
        RepEvent_Tm: '',
        RepOrderTemplate_id:''
      },
      editedItem:{
        ApiUser_id: '',
        ApiUser_GivenName: '',
        ApiUser_EMail: '',
        ApiUserType_id: 'P'
      },
      editedItemS: {
        ApiUser_id:'',
        ApiUser_Supplier:'',
        SupplierStart_Dt: new Date().toISOString().split('T')[0], 
        SupplierEnd_Dt: '9999-12-31'
      },
      RepOrderStatus:[],
      RepOrderItemsStatus:[],
      ReceiversItem: {
        MotherSupplier_id: '',
        RepOrder_id: '',
        RepOrderGroupReceivers_id: '',
        RepOrderItemsStatus_id: '1',
        RepEvent_id: this.token,
        LastOpRepUser_id: this.user,
        RepEvent_Dt: this.fechaHoy,
        RepEvent_Tm: ''
      },
      idRules: [
        v => !!v || 'Rol ID es requerido',
        v => (v && v.length <= 30) || 'Role ID debe tener menos de 30 caracteres',
      ],
      descRules: [
        v => !!v || 'Descripcion es requerida',
        v => (v && v.length <= 61) || 'Descripcion debe tener menos de 30 caracteres',
      ],
      emailRules: [
        v => !!v || 'El correo es requerido',
        v => /.+@.+\..+/.test(v) || 'El correo debe tener un formato válido'
      ],
      config: {
        headers: {
          //'Authorization': 'Bearer ' + sessionStorage.getItem('access_token'),
          "api-user": sessionStorage.getItem('ApiUser_id')
        }
      }
    }),
  
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nuevo Proceso' : 'Editar Proceso'
      },
      destinatariosConClave() {
        // Devolvemos una copia con el idCompuesta SOLO PARA LA VISTA
        return this.destinatarios.map(item => ({
          ...item,
          idCompuesta: `${item.ApiUser_id}_${item.ApiUser_Supplier}`,
        }))
      },
      filteredItems() {
        if (!this.RepOrder || !Array.isArray(this.RepOrder)) return [];

        return this.RepOrder.filter(item => {
          return Object.keys(this.filters).every(key => {
            const filterValue = this.filters[key];
            if (!filterValue) return true;

            let itemValue = item[key];

            // Manejo especial para campos con descripción asociada
            if (key === 'RepOrderStatus_id') {
              const status = this.getRepOrderStatus(item.RepOrderStatus_id);
              itemValue = status && status.RepOrderStatus_Desc ? status.RepOrderStatus_Desc : '';
            }

            if (itemValue == null) return false;

            return itemValue.toString().toLowerCase().includes(filterValue.toLowerCase());
          });
        });
      }
    },
  
    watch: {
      dialog (val) {
        val || this.close()
      },
      'ReceiversItem.MotherSupplier_id'(nuevosIds) {
        // Actualiza la tabla con los proveedores seleccionados
        this.proveedores = this.proveedores.map(item => ({
          ...item,
          RepOrder_id: this.OrdenItem.RepOrder_id
        }));
        this.itemsEnTabla = this.proveedores.filter(p =>
          nuevosIds.includes(p.MotherSupplier_id)
        );
      }
    },
  
    created () {
      this.initialize()
    },
  
    methods: {
      exportarExcelCarga() {
        const Archivo = "Resultado_Carga_CMP"+this.OrdenItem.RepOrder_id+"_"+this.fechaHoy
        
        const sheets = [
          {
            nombre: 'Destinatarios',
            headers: this.headers1,
            data: this.destinatarios
          },
          {
            nombre: 'Data',
            headers: this.headers2,
            data: this.data2
          },
          {
            nombre: 'Errores',
            headers: this.headers3,
            data: this.errores
          }
        ]
        this.exportDataExcel(sheets, Archivo)
      },

      descargarTemplateImportacion() {
        const ids = [...new Set(
          this.filteredItems
            .map(item => item.RequestProposal_id)
            .filter(id => id !== null && id !== undefined && id !== '')
        )]

        this.importResultVisible = false

        if (ids.length === 0) {
          this.importResultType = 'warning'
          this.importResultTitle = 'Sin registros'
          this.importResultMessage = 'No existen pedidos filtrados para generar la Plantilla TP.'
          this.importResultVisible = true
          return
        }

        if (this.templateProgress) return

        this.templateProgress = true
        this.templateMessage = 'Generando Plantilla TP...'

        const configDownload = {
          headers: this.config.headers,
          responseType: 'blob',
          timeout: 300000
        }

        axios.post(
          this.api_tool_url + '/get_RepOrderPenalityTemplate',
          { RequestProposal_ids: ids },
          configDownload
        )
        .then(response => {
          this.templateMessage = 'Descargando Plantilla TP...'

          const contentDisposition = response.headers['content-disposition']
          let filename = 'Plantilla_TP.xlsx'

          if (contentDisposition) {
            const match = contentDisposition.match(/filename="?([^"]+)"?/)
            if (match && match[1]) filename = match[1]
          }

          saveAs(
            new Blob(
              [response.data],
              { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
            ),
            filename
          )
        })
        .catch(error => {
          if (error.code === 'ECONNABORTED') {
            this.importResultType = 'error'
            this.importResultTitle = 'Tiempo de espera agotado'
            this.importResultMessage = 'La generación de la Plantilla TP superó el tiempo máximo permitido. Intente nuevamente con menos registros filtrados.'
            this.importResultVisible = true
            return
          }

          if (error.response && error.response.status === 405) {
            this.importResultType = 'error'
            this.importResultTitle = 'Servicio no disponible'
            this.importResultMessage = 'El servicio de generación de Plantilla TP no tiene habilitado el método requerido.'
            this.importResultVisible = true
            return
          }

          if (error.response && error.response.data instanceof Blob) {
            const reader = new FileReader()

            reader.onload = () => {
              let mensaje = 'Ocurrió un error al generar la Plantilla TP.'

              try {
                const data = JSON.parse(reader.result)
                mensaje = data.ResultError || data.message || mensaje
              } catch (e) {
                mensaje = 'Ocurrió un error al generar la Plantilla TP.'
              }

              this.importResultType = 'error'
              this.importResultTitle = 'Error generando Plantilla TP'
              this.importResultMessage = mensaje
              this.importResultVisible = true
            }

            reader.readAsText(error.response.data)
          } else {
            this.importResultType = 'error'
            this.importResultTitle = 'Error generando Plantilla TP'
            this.importResultMessage = 'Ocurrió un error al generar la Plantilla TP.'
            this.importResultVisible = true
          }
        })
        .finally(() => {
          this.templateProgress = false
          this.templateMessage = 'Generando Plantilla TP...'
        })
      },

      exportarExcelOrdenes() {
        const Archivo = "PNS-"+this.fechaHoy
        const filteredIds = this.filteredItems.map(item => item.RepOrder_id)
        const subitemsData = this.subitems.filter(sub => filteredIds.includes(sub.RepOrder_id))
        const subitemsData2 = subitemsData.map(sub => {
          const status = this.getRepOrderItemsStatus(sub.RepOrderItemsStatus_id)
          const status2 = this.getSupplier(sub.MotherSupplier_id)
          return {
            ...sub,
            status_desc: status && status.RepOrderItemsStatus_Desc ? status.RepOrderItemsStatus_Desc : '',
            MotherSupplier_Desc: status2 && status2.MotherSupplier_Desc ? status2.MotherSupplier_Desc : ''
          }
        })
        const OrdItem = this.filteredItems.map(sub => {
          const status = this.getRepOrderStatus(sub.RepOrderStatus_id)
          return {
            ...sub,
            RepOrderStatus_id: status && status.RepOrderStatus_Desc ? status.RepOrderStatus_Desc : ''
          }
        })
        console.log(OrdItem)
        const subheader=[
          { text: 'Pedido_Id',  title: 'Pedido_Id', value: 'RequestProposal_id', align: 'center', sortable: true, key: 'RequestProposal_id'},
          { text: 'Fecha_Emisión',  title: 'Fecha_Emisión', value: 'RequestProposal_Dt', align: 'center', sortable: true, key: 'RequestProposal_Dt'},
          { text: 'Tipo_Pedido_Id',  title: 'Tipo_Pedido_Id', value: 'RequestProposalSrc_id', align: 'center', sortable: true, key: 'RequestProposalSrc_id'},
          { text: 'Tipo_Pedido_Desc',  title: 'Tipo_Pedido_Desc', value: 'RequestProposalSrc_Desc', align: 'center', sortable: true, key: 'RequestProposalSrc_Desc'},
          { text: 'OC',  title: 'OC', value: 'VendorPurchaseOrder_Num', align: 'center', sortable: true, key: 'VendorPurchaseOrder_Num'},
          { text: 'Tipo_OC',  title: 'Tipo_OC', value: 'VendorPurchaseOrderType_id', align: 'center', sortable: true, key: 'VendorPurchaseOrderType_id'},
          { text: 'Folio',  title: 'Folio', value: 'Supplier_id', align: 'center', sortable: true, key: 'Supplier_id'},
          { text: 'Folio_Desc',  title: 'Folio_Desc', value: 'Supplier_Description', align: 'center', sortable: true, key: 'Supplier_Description'},
          { text: 'Punto Id',  title: 'Punto Id', value: 'OpPoint_id', align: 'center', sortable: true, key: 'OpPoint_id'},
          { text: 'Punto_Desc',  title: 'Punto_Desc', value: 'OpPoint_Description', align: 'center', sortable: true, key: 'OpPoint_Description'},
          { text: 'Fecha_Recepción',  title: 'Fecha_Recepción', value: 'Reception_Dt', align: 'center', sortable: true, key: 'Reception_Dt'},
          { text: 'Fecha_Cierre',  title: 'Fecha_Cierre', value: 'Closing_Dt', align: 'center', sortable: true, key: 'Closing_Dt'},
          { text: 'Cant_Pedida',  title: 'Cant_Pedida', value: '_OC_Purchase_Qty', align: 'center', sortable: true, key: '_OC_Purchase_Qty'},
          { text: 'Cant_Recibida',  title: 'Cant_Recibida', value: '_OC_Received_Qty', align: 'center', sortable: true, key: '_OC_Received_Qty'},
          { text: 'Estado_Id',  title: 'Estado_Id', value: 'RequestProposalStatus_Cd', align: 'center', sortable: true, key: 'RequestProposalStatus_Cd'},
          { text: 'Estado_Desc',  title: 'Estado_Desc', value: 'RequestProposalStatus_Desc', align: 'center', sortable: true, key: 'RequestProposalStatus_Desc'},
          { text: 'NS',  title: 'NS', value: 'ServiceLevel_Pct', align: 'center', sortable: true, key: 'ServiceLevel_Pct'},
          { text: 'Status_Oc',  title: 'Status_Oc', value: 'RepOrderStatus_id', align: 'center', sortable: true, key: 'RepOrderStatus_id'},
          { text: 'Ultima_Tipificación', title: 'Ultima_Tipificacion', value: 'RepOrderPenalityReason_Desc', align: 'center', sortable: true, key: 'RepOrderPenalityReason_Desc'},
          { text: 'Fecha_Actualización',  title: 'Fecha_Actualización', value: 'OC_Update_Dt', align: 'center', sortable: true, key: 'OC_Update_Dt'},
          { text: 'Hora_Actualización',  title: 'Hora_Actualización', value: 'OC_Update_Tm', align: 'center', sortable: true, key: 'OC_Update_Tm'}
        ]
        const sheets = [
          {
            nombre: 'PNS',
            headers: subheader,
            data: OrdItem
          },
          {
            nombre: 'Detalle',
            headers: subheader,
            data: subitemsData2
          }
        ]
        this.exportDataExcel(sheets, Archivo)
      },
      exportDataExcel(multipleSheets, Archivo) {
        const wb = XLSX2.utils.book_new()

        multipleSheets.forEach(sheet => {
          if (!Array.isArray(sheet.data) || sheet.data.length === 0) return

          const headers = sheet.headers.map(h => h.text)
          const rows = sheet.data.map(row =>
            sheet.headers.map(h => {
              const val = row[h.value]
              return val != null ? val : ''
            })
          )

          const ws = XLSX2.utils.aoa_to_sheet([headers, ...rows])

          // Estilos para los encabezados (fila 1)
          headers.forEach((_, colIndex) => {
            const cellRef = XLSX2.utils.encode_cell({ c: colIndex, r: 0 })
            if (!ws[cellRef]) return
            ws[cellRef].s = {
              font: { bold: true, color: { rgb: "FFFFFF" }, sz: 12 },
              fill: { fgColor: { rgb: "007ACC" } },
              alignment: { horizontal: "center", vertical: "center" },
              border: {
                top: { style: "thin", color: { rgb: "000000" } },
                bottom: { style: "thin", color: { rgb: "000000" } },
                left: { style: "thin", color: { rgb: "000000" } },
                right: { style: "thin", color: { rgb: "000000" } }
              }
            }
          })

          // Ajustar ancho columnas según longitud del header
          ws['!cols'] = headers.map(h => ({ wch: Math.max(10, h.length) }))

          XLSX2.utils.book_append_sheet(wb, ws, sheet.nombre || 'Hoja')
        })

        const wbout = XLSX2.write(wb, { bookType: 'xlsx', type: 'array', cellStyles: true })
        saveAs(new Blob([wbout], { type: 'application/octet-stream' }), Archivo + '.xlsx')
      },
      getFilterKey(column) {
        return column.title === 'Estado' ? 'RepOrderStatus_Desc' : column.value;
      },
      customFilter(value, search, item, column) {
        if (!search) return true;
          const lowerSearch = search.toLowerCase();

          if (column.value === 'RepOrderStatus_id') {
            const status = this.getRepOrderStatus(item.RepOrderStatus_id);
            const desc = status && status.RepOrderStatus_Desc
              ? status.RepOrderStatus_Desc.toLowerCase()
              : '';
            return desc.includes(lowerSearch);
          }

          return String(value).toLowerCase().includes(lowerSearch);
      },
      toggleSeleccionarTodo() {
        this.destinatarios.forEach(item => {
          item.selected = this.selectAll;
        });
      },
      mostrarProveedor(item) {
        if (!item) return ''
        return `${item.MotherSupplier_id} - ${item.MotherSupplier_Desc}`
      },
      getItemKey(item) {
        return `${item.ApiUser_id}_${item.ApiUser_Supplier}`;
      },
      generarUsuario() {
        const val = this.editedItem.ApiUser_GivenName
          .trim()
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "") // quitar acentos
          .replace(/[^a-z\s]/g, ""); // quitar símbolos

        const partes = val.split(/\s+/);

        if (partes.length >= 2) {
          const primero = partes[0];
          const ultimo = partes[partes.length - 1];
          const numero = Math.floor(0 + Math.random() * 99999999); // número aleatorio
          this.editedItem.ApiUser_id = `${primero}_${ultimo}_${numero}`;
          this.editedItemS.ApiUser_id = `${primero}_${ultimo}_${numero}`;
        } else {
          this.editedItemS.ApiUser_id = '';
          this.editedItem.ApiUser_id = '';
        }
      },
      nombreCompleto() {
        const val = this.editedItem.ApiUser_GivenName
        const partes = val
          .trim()
          .toLowerCase()
          .normalize("NFD") // Quita acentos
          .replace(/[\u0300-\u036f]/g, "") // Quita caracteres diacríticos
          .split(/\s+/)

        if (partes.length >= 2) {
          const primero = partes[0]
          const ultimo = partes[partes.length - 1]
          const numero = Math.floor(0 + Math.random() * 99999999)
          this.editedItem.ApiUser_id = `${numero}`
          this.editedItemS.ApiUser_id = `${numero}`
        } else {
          this.editedItem.ApiUser_id = ''
          this.editedItemS.ApiUser_id = ''
        }
      },
      exportData() {
        const headersCsv = this.headers.map(header => header.title).join(',')
        const rows = this.filteredItems.map(item =>this.headers.map(header => item[header.value]).join(','))
        
        const csvContent = [headersCsv, ...rows].join('\n')
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
        const link = document.createElement('a')
        const url = URL.createObjectURL(blob)
        link.setAttribute('href', url)
        link.setAttribute('download', 'datos_exportados.csv')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      },
      initialize () {

        EventBus.$emit('actualizarNotificaciones')

        this.destinatarios = []
        this.data2 = []
        this.data3 = []
        this.errores = []
        this.files = []
        this.files2 = []
        this.tabs = 0
        this.RepOrderTemplate2.RepOrderTemplate2_id = 0
        this.mostrarTabs = false
        this.items = [
          {
            icon: 'mdi-account-box',
            text: 'Destinatarios'
          },       
          {
            icon: 'mdi-file-document',
            text: 'Mail'
          },
          {
            icon: 'mdi-alert-circle',
            text: 'Errores'
          }
        ]

        this.OrdenItem.RepOrder_id = ''
        this.OrdenItem.RepOrder_Desc= ''
        this.OrdenItem.RepOrder_Text= ''
        this.OrdenItem.RepOrderStatus_id= '1'
        this.OrdenItem.CreationRepEvent_id= this.token
        this.OrdenItem.CreationRepUser_id= this.user
        this.OrdenItem.CreationRepEvent_Dt= this.fechaHoy
        this.OrdenItem.CreationRepEvent_Tm= ''
        this.OrdenItem.RepEvent_id= this.token
        this.OrdenItem.LastOpRepUser_id= this.user
        this.OrdenItem.RepEvent_Dt= this.fechaHoy
        this.OrdenItem.RepEvent_Tm= ''

        this.editedItem.ApiUser_id= '',
        this.editedItem.ApiUser_GivenName= '',
        this.editedItem.ApiUser_EMail= '',
        this.editedItem.ApiUserType_id= 'P'

        this.editedItemS.ApiUser_id='',
        this.editedItemS.ApiUser_Supplier='',
        this.editedItemS.SupplierStart_Dt= this.fechaHoy, 
        this.editedItemS.SupplierEnd_Dt= '9999-12-31'

        this.ReceiversItem.RepEvent_id= this.token
        this.ReceiversItem.LastOpRepUser_id= this.user
        this.ReceiversItem.RepEvent_Dt= this.fechaHoy
        this.listOr = true
        this.loading2 = false
        this.loading = true
        this.newcmp = false
        let filter = {}

        axios.post(this.api_tool_url + '/get_ApiUserSupplier', {ApiUser_id:this.$store.state.ApiUser_id}, this.config)
        .then(response => { 
              response.data.ResultRows.forEach(info => {
                this.ApiUserSupplier.push(info.MotherSupplier_Desc)
              })

              axios.post(this.api_tool_url + '/get_UserOppoint2', {ApiUser_id:this.$store.state.ApiUser_id}, this.config)
              .then(response => {
                  response.data.ResultRows.forEach(info => {
                    this.oppoint2.push(info.OpPoint_id)
                  })

                  if (this.$store.state.ApiUserType_id.trim() === 'P'){
                    filter.Supplier = this.ApiUserSupplier
                  }
                  else if(this.oppoint2.length > 0){
                    filter.ApiPunto = this.oppoint2
                  }

                  axios.post(this.api_tool_url + '/get_RepOrderPenality', filter, this.config)
                  .then(response => {
                    this.RepOrder = response.data.ResultRows
                    this.loading = false
                  })
                  .catch(error => {
                    this.RepOrder = []
                    this.loading = false
                    alert(error.response.data.message)
                  })

              })
              .catch(error => {
                  this.oppoint2 = []
                  alert(error.response.data.message)
              })
          })
          .catch(error => {
            this.ApiUserSupplier = []
            alert(error.response.data.message)
        })

        

        
        

        axios.post(this.api_tool_url + '/get_RepOrderItemsStatus', {}, this.config)
        .then(response => {
          this.RepOrderItemsStatus = response.data.ResultRows
        })
        .catch(error => {
          this.RepOrderItemsStatus = []
          alert(error.response.data.message)
        })

        axios.post(this.api_tool_url + '/get_RepOrderStatus', {}, this.config)
        .then(response => {
          this.RepOrderStatus = response.data.ResultRows
        })
        .catch(error => {
          this.RepOrderStatus = []
          alert(error.response.data.message)
        })

        axios.post(this.api_tool_url + '/get_RepOrderPenalityReason', {}, this.config)
        .then(response => {
          this.RepOrderPenalityReason = response.data.ResultRows
        })
        .catch(error => {
          this.RepOrderPenalityReason = []
          alert(error.response.data.message)
        })

        axios.post(this.api_tool_url + '/get_MotherSupplier', {}, this.config)
        .then(response => {
          this.proveedores = response.data.ResultRows
        })
        .catch(error => {
          this.proveedores = []
          alert(error.response.data.message)
        })
        
        
      },

      updateDescription() {
        const item = this.RepOrderTemplate.find(t => t.RepOrderTemplate_id === this.RepOrderTemplate2.RepOrderTemplate2_id);
        this.OrdenItem.RepOrder_Text = item ? item.RepOrderTemplate_Text : '';
      },
      newtItem() {
        this.dialog = true
      },
      agregarNuevo(){
        this.newcmp = true
        this.listOr = false
      },
      listaCMP(){
        this.newcmp = false
        this.listOr = true
        this.initialize()
      },
      onCancel(item){
        const filter = {
          token: this.token,
          cmp_id: item.RepOrder_id,
          user: this.user
        }
        this.viewrepo = false
        this.progressBar = true
        axios.post(this.api_tool_url + '/finalizar_orden', filter, this.config)
        .then(response => {
          if(response.data.ResultRows.length > 0){
            axios.post(this.api_tool_url + '/get_RepOrder', {}, this.config)
            .then(response => {
              this.RepOrder = response.data.ResultRows
              this.progressBar = false
            })
            .catch(error => {
              this.RepOrder = []
              alert(error.response.data.message)
            })
          }
        })
        .catch(error => {
            alert(error.response.data.message)
        })

      },
      enviarRespuesta(MotherSupplier,RepOrder2){
        const id = RepOrder2.RequestProposal_id
        const MotherSupplier_Desc = RepOrder2.Supplier_Description
        this.loading= true

        const DescFolio_id = RepOrder2.Supplier_id;

        const ahora = new Date();
        const horas = ahora.getHours().toString().padStart(2, '0');
        const minutos = ahora.getMinutes().toString().padStart(2, '0');
        const segundos = ahora.getSeconds().toString().padStart(2, '0');
        this.hora = `${horas}:${minutos}:${segundos}`;

        let data2 = new FormData();
        

        const RepOrderPenalityReason_Descr = this.getRepOrderPenalityReason(this.RepOrderPenalityReason.RepOrderPenalityReason_id).RepOrderPenalityReason_Desc
        

        const filter = {
          RequestProposal_id: id,
          RepOrder: RepOrder2,
          Supplier_id: DescFolio_id,
          Supplier_Description: MotherSupplier_Desc,
          RepEvent_Tm: this.hora,
          RepEvent_id: this.token,
          LastOpRepUser_id: this.user,
          Usuario_Logistico: this.$store.state.ApiUser_GivenName,
          RepEvent_Dt: this.fechaHoy,
          RepOrder_Text: this.respuesta,
          File: data2
        }
        data2.append('file', document.getElementById('file2').files[0]);
        data2.append('RequestProposal_id', id);
        data2.append('RepOrder_', RepOrder2);
        data2.append('OpPoint_id', RepOrder2.OpPoint_id);
        data2.append('RepOrder', RepOrder2.VendorPurchaseOrder_Num);
        data2.append('CreationRepEvent_Dt',this.fechaHoy);
        data2.append('Supplier_id', DescFolio_id);
        data2.append('Supplier_Description', MotherSupplier_Desc);
        data2.append('RepEvent_Tm', this.hora);
        data2.append('RepEvent_id', this.token);
        data2.append('LastOpRepUser_id', this.user);
        data2.append('Usuario_Logistico', this.$store.state.ApiUser_GivenName);
        data2.append('RepEvent_Dt', this.fechaHoy);
        data2.append('RepOrder_Text', this.respuesta);
        data2.append('RepOrderPenalityReason_Desc', RepOrderPenalityReason_Descr);

        axios.post(this.api_tool_url + '/EnviarRespPenality', data2, this.config)
        .then(response => {
          if(response.data.ResultRows === 'OK'){
            this.respuesta = ''
            this.initialize()
            //this.viewrepo = true
            this.loading = false
            alert("Mensaje enviado.")
          }
          else{
            this.respuesta = ''
            //this.viewrepo = true
            this.loading = false
            alert(response.data.ResultError)
          }
        })
        .catch(error => {
          alert(error.response.data.message)
          this.respuesta = ''
          //this.viewrepo = true
          this.loading = false
        })

      },
      GetRepOrder(item) {

        const id = item.RequestProposal_id
        const filter = {
          RequestProposal_id: id
        }
        this.RepOrder2=this.RepOrder.find(r => r.RequestProposal_id === id)
        //this.subitems2=this.subitems.filter(sub => sub.RequestProposal_id === id)
        this.e2=this.RepOrder2.RepOrderStatus_id
        this.viewrepo = true
        this.overlay_de = true
        axios.post(this.api_tool_url + '/get_RepOrderPenalityLine', filter, this.config)
        .then(response => {
          this.RepOrderItems = response.data.ResultRows
          this.subitems2 = response.data.ResultRows
        })
        .catch(error => {
          this.RepOrderItems = []
          alert(error.response.data.message)
        })

        axios.post(this.api_tool_url + '/get_RepOrderItemsPenality', filter, this.config)
        .then(response => {
          this.RepOrderItemsPenality = response.data.ResultRows
          this.overlay_de = false
        })
        .catch(error => {
          this.RepOrderItemsPenality = []
          this.overlay_de = false
          alert(error.response.data.message)
        })
      },
      editOrder(item) {
        const id = item.RepOrder_id
        router.replace({
          name: 'RepOrder',
          params: {
            token: this.token,
            id: id
          }
        });
      },
      getRepOrderPenalityReason(statusId) {
        return this.RepOrderPenalityReason.find(s => s.RepOrderPenalityReason_id === statusId) || {}
      },
      getSupplier(statusId) {
        return this.proveedores.find(s => s.MotherSupplier_id === statusId) || {}
      },
      getRepOrderStatus(statusId) {
        return this.RepOrderStatus.find(s => s.RepOrderStatus_id === statusId) || {}
      },
      getRepOrderItemsStatus(statusId) {
        return this.RepOrderItemsStatus.find(s => s.RepOrderItemsStatus_id === statusId) || {}
      },
      getSubitems(RequestProposal_id) {
        return this.subitems.filter(sub => sub.RequestProposal_id === RequestProposal_id)
      },
      save () {
        this.editedItem.ApiUserType_id = 'P'
        this.loading2 = true
        axios.post(this.api_tool_url + '/ins_user', this.editedItem, this.config)
        .then(response => {
          if(response.data.ResultRows.length >= 1){
            axios.post(this.api_tool_url + '/upd_ins_userMotherSupplier2', this.editedItemS, this.config)
            .then(response => {
              this.close()
            })
            .catch(error => {
              alert(error.response.data.message)
            })
          }
        })
        .catch(error => {
          alert(error.response.data.message)
        })
      },
      carga() {
        this.btn = true
        this.progressBar = true
        this.msj_proceso = "Por favor aguarde un momento mientras se procesa la solicitud. ¡No cerrar esta ventana!"
        let data = new FormData();
        this.mvm = []
        this.destinatarios = []
        this.headers2 = []
        this.data2 = []
        this.headers6 = []
        this.data3 = []
        this.errores = []
        this.items = [
          {
            icon: 'mdi-account-box',
            text: 'Destinatarios'
          },       
          {
            icon: 'mdi-file-document',
            text: 'Mail'
          },
          {
            icon: 'mdi-alert-circle',
            text: 'Errores'
          }
        ]
        this.Observaciones = []
        this.tabs = 0
        this.taberror = false
        this.mostrarTabs = false
        data.append('file', document.getElementById('file').files[0]);
        data.append('token', this.token);
        data.append('cmp_id', this.OrdenItem.RepOrder_id);
        data.append('user', this.user);
        
        axios.post(this.api_tool_url + '/fileUploadCMP2', data, this.config)
        .then(response => {
          this.headers2 = response.data.ResultHeader
          const hojas = Object.keys(response.data.ResultHeader);
          if(hojas && hojas.length >= 1) {
            this.destinatarios = response.data.ResultUsers
            this.destinatarios.forEach(item => {
              this.$set(item, 'selected', false); // necesario para que Vue lo reactive
              this.$set(item, 'idCompuesta', `${item.ApiUser_id}_${item.ApiUser_Supplier}`);
            });
            this.NombreHoja1 = hojas[0]
            this.headers2 = response.data.ResultHeader[hojas[0]]
            this.data2 = response.data.ResultRows[hojas[0]]
            if (hojas.length > 1) {
              this.NombreHoja2 = hojas[1]
              this.headers6 = response.data.ResultHeader[hojas[1]]
              this.data3 = response.data.ResultRows[hojas[1]]
            }
            const insertIndex = 1; 
            const itemsDatos = hojas.map((hoja, i) => ({
              icon: 'mdi-database',
              text: `Datos - ${hoja}`
            }));
            this.items.splice(insertIndex, 0, ...itemsDatos);
            this.errores =  response.data.ResultError
            if(response.data.ResultError.length > 0  ){
              if (hojas.length > 1){
                this.tabs = 4
              }
              else{
                this.tabs = 3
              }
              this.taberror = true
            }
            this.Observaciones= response.data.ResultError
            this.mostrarTabs = true
            this.progressBar = false
            this.btnG = false
            
            this.msj_proceso = 'Se realizo la comunicación correctamente.'
          }
          else {
            this.progressBar = false
            this.loading = false
            this.msj_proceso = error
          }
          this.btn = false
        })
        .catch(error => {
          this.btn = false
          this.progressBar = false
          if (error.response && error.response.data && error.response.data.message) {
            this.msj_proceso = error.response.data.message;
          } 
          else 
          {
            this.msj_proceso = 'Ocurrió un error al procesar el archivo.';
          }
          this.active = true
        })
                    
                    
      },
      generar(){
        this.newcmp = false
        this.listOr = true
        this.loading = true
      },
      editItem (item) {
        this.editedIndex = this.RepOrderProcess.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },
  
      deleteItem (item) {
        const index = this.RepOrderProcess.indexOf(item)
        confirm('¿Confirma la eliminación del registro?') && this.deleteUserMenu(index)
      },
  
      deleteUserMenu(index) {
        let usermenus_tmp = this.RepOrderProcess[index]
        //delete usermenus_tmp.RepOrderProcess_id
        axios.post(this.api_tool_url + '/del_RepOrderProcess', usermenus_tmp, this.config)
          .then(response => {
            this.RepOrderProcess.splice(index, 1)
            this.close()
            })
          .catch(error => {
            this.RepOrderProcess = []
            alert(error.response.data.message)
            })
      },
  
      close () {
        this.dialog = false
        this.dialog_new = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },
  
      GenerarCMP() {
        
        this.dialog_new = true
        const ahora = new Date();
        const horas = ahora.getHours().toString().padStart(2, '0');
        const minutos = ahora.getMinutes().toString().padStart(2, '0');
        const segundos = ahora.getSeconds().toString().padStart(2, '0');
        this.hora = `${horas}:${minutos}:${segundos}`;

        this.OrdenItem.RepEvent_Tm = this.hora
        this.OrdenItem.RepOrderTemplate_id = this.RepOrderTemplate2.RepOrderTemplate2_id
        const RepOrderTemplate_Descr = this.getTemplate(this.RepOrderTemplate2.RepOrderTemplate2_id).RepOrderTemplate_Desc
        const folios_new  = this.destinatarios.filter(item => item.selected === true)
        
        const proveedoresUnicos = Array.from(
                      new Map(folios_new.map(p => [p.ApiUser_Supplier, p])).values()
        );

        const filter = {
          RepOrder_id: this.OrdenItem.RepOrder_id,
          RepEvent_id: this.token,
          LastOpRepUser_id: this.user,
          Usuario_Logistico: this.$store.state.ApiUser_GivenName,
          RepEvent_Dt: this.fechaHoy,
          RepEvent_Tm: this.hora,
          RepOrder: this.OrdenItem,
          RepOrderGroupReceivers: this.destinatarios.filter(item => item.selected === true),
          RepOrderData: this.data2,
          Header: this.headers2,
          RepOrderData2: this.data3,
          Header3: this.headers6,
          RepOrderTemplate_Desc: RepOrderTemplate_Descr,
          Hoja1Nombre: this.NombreHoja1,
          Hoja2Nombre: this.NombreHoja2
        }

        this.e1 = 1
        this.progressBar1 = true
        this.step_error1 = true
        this.step_error2 = true
        this.step_error3 = true
        this.step_color1 = "primary",
        this.step_color2 = "primary",
        this.step_color3 = "primary",
        this.msj_proceso = "Por favor aguarde un momento mientras se procesa la solicitud. ¡No cerrar esta ventana!"

        axios.post(this.api_tool_url + '/SendCMP', filter, this.config)
        .then(response => {
          if(response.data.ResultRows === 'OK'){
            this.e1 = 1
            this.step_color1 = "#008000"
            this.step_error1 = true
            this.progressBar1 = false
            this.msj_proceso = 'Se registro la comunicación correctamente.'
            this.e1 = 2
            this.progressBar1 = true
            
            axios.post(this.api_tool_url + '/SendMailCMP2', filter, this.config)
            .then(response => {
              if(response.data.ResultRows === 'OK') {
                this.e1 = 2
                this.step_color2 = "#008000"
                this.progressBar1 = false
                this.step_error2 = true
                this.msj_proceso = 'Se registraron los destinatarios correctamente.'
                
                this.e1 = 3
                this.progressBar1 = true
                this.msj_proceso = 'Finalizando Comunicación.'

                const filter2 = {RepOrder_id: this.OrdenItem.RepOrder_id}
                
                axios.post(this.api_tool_url + '/get_RepOrder', filter2, this.config)
                .then(response => {
                  if (response.data.ResultRows.length > 0){
                    this.e1 = 3
                    this.step_color3 = "#008000"
                    this.progressBar1 = false
                    this.step_error3 = true
                    this.msj_proceso = 
                    `Finalizo el envío de la comunicación.\n` +
                    `Orden de CMP: ${this.OrdenItem.RepOrder_id} - ${this.OrdenItem.RepOrder_Desc}.\n`
                    //  +`Proveedores:\n` +proveedoresUnicos.map(p => `\t${p.ApiUser_Supplier} - ${p.MotherSupplier_Desc}`).join('\n');
                    this.destinatarios = []
                    this.data2 = []
                    this.errores = []
                    this.files = []
                    this.tabs = 0
                    this.RepOrderTemplate2.RepOrderTemplate2_id = 0
                    this.mostrarTabs = false

                    this.OrdenItem.RepOrder_id = ''
                    this.OrdenItem.RepOrder_Desc= ''
                    this.OrdenItem.RepOrder_Text= ''
                    this.OrdenItem.RepOrderStatus_id= '1'
                    this.OrdenItem.CreationRepEvent_id= this.token
                    this.OrdenItem.CreationRepUser_id= this.user
                    this.OrdenItem.CreationRepEvent_Dt= this.fechaHoy
                    this.OrdenItem.CreationRepEvent_Tm= ''
                    this.OrdenItem.RepEvent_id= this.token
                    this.OrdenItem.LastOpRepUser_id= this.user
                    this.OrdenItem.RepEvent_Dt= this.fechaHoy
                    this.OrdenItem.RepEvent_Tm= ''

                    this.editedItem.ApiUser_id= '',
                    this.editedItem.ApiUser_GivenName= '',
                    this.editedItem.ApiUser_EMail= '',
                    this.editedItem.ApiUserType_id= 'P'

                    this.editedItemS.ApiUser_id='',
                    this.editedItemS.ApiUser_Supplier='',
                    this.editedItemS.SupplierStart_Dt= new Date().toISOString().split('T')[0], 
                    this.editedItemS.SupplierEnd_Dt= '9999-12-31'

                    this.initialize()
                    EventBus.$emit('actualizarNotificaciones')

                  }
                  else{
                    this.e1 = 3
                    this.step_color3 = "#C0392B"
                    this.step_error3 = false
                    this.progressBar1 = false
                    this.msj_proceso = 'Fallo la finalización de la orden.'
                  }
                })
                .catch(error => {
                  this.e1 = 3
                  this.step_color3 = "#C0392B"
                  this.step_error3 = false
                  this.progressBar1 = false
                  this.msj_proceso = 'Fallo la finalización de la orden.'
                  alert(error.response.data.message)
                })
                
              }
              else{
                this.e1 = 2
                this.step_color2 = "#C0392B"
                this.step_error2 = false
                this.progressBar1 = false
                this.msj_proceso = 'Fallo el registro de destinatarios.'
              }

            })
            .catch(error => {
              this.e1 = 2
              this.step_color2 = "#C0392B"
              this.step_error2 = false
              this.progressBar1 = false
              this.msj_proceso = 'Fallo el registro de destinatarios.'
              alert(error.response.data.message)
            })
          }
          else{
            this.e1 = 1
            this.step_color1 = "#C0392B"
            this.step_error1 = false
            this.progressBar1 = false
            this.msj_proceso = 'Fallo el registro la comunicación. '
            alert(response.data.ResultError)
          } 
        })
        .catch(error => {
          this.e1 = 1
          this.step_color1 = "#C0392B"
          this.step_error1 = false
          this.progressBar1 = false
          this.msj_proceso = 'Fallo el registro la comunicación.'
          alert(error.response.data.message)
        })
        
      },
      importarExcelOrdenes(event) {
        const file = event.target.files[0]
        if (!file) return

        this.importResultVisible = false

        if (!file.name.toLowerCase().endsWith('.xlsx')) {
          this.importResultType = 'error'
          this.importResultTitle = 'Archivo inválido'
          this.importResultMessage = 'El archivo debe tener formato .xlsx.'
          this.importResultVisible = true
          event.target.value = ''
          return
        }

        this.importProgress = true
        this.importProgressComplete = false
        this.importMessage = 'Procesando archivo de tipificaciones...'

        const data = new FormData()
        data.append('file', file)

        const configImport = {
          headers: this.config.headers,
          timeout: 300000
        }

        axios.post(
          this.api_tool_url + '/ins_RepOrderPenalityMasivo',
          data,
          configImport
        )
        .then(response => {
          if (response.data.ResultRows === 'OK') {
            const procesados = response.data.ResultProcessed || 0
            const duplicados = response.data.ResultDuplicated || 0
            const errores = response.data.ResultRejected || 0

            this.importProgressComplete = true
            this.importMessage = 'Proceso finalizado'

            if (errores > 0 || duplicados > 0) {
              this.importResultType = 'warning'
              this.importResultTitle = 'Importación finalizada con observaciones'
            } else {
              this.importResultType = 'success'
              this.importResultTitle = 'Importación finalizada correctamente'
            }

            this.importResultMessage =
              `Procesados correctamente: ${procesados}. Duplicados: ${duplicados}. Errores: ${errores}. ` +
              `Se envió un correo con el resumen de la importación.`

            if (response.data.ResultMailError) {
              this.importResultType = 'warning'
              this.importResultMessage =
                `Procesados correctamente: ${procesados}. Duplicados: ${duplicados}. Errores: ${errores}. ` +
                `La importación finalizó, pero no fue posible enviar el correo de resumen.`
            }

            setTimeout(() => {
              this.importProgress = false
              this.importResultVisible = true
              this.initialize()
            }, 600)
          } else {
            this.importProgress = false
            this.importResultType = 'error'
            this.importResultTitle = 'Error en la importación'
            this.importResultMessage = response.data.ResultError || 'Ocurrió un error durante la importación.'
            this.importResultVisible = true
          }
        })
        .catch(error => {
          let mensaje = 'Ocurrió un error al procesar el archivo.'

          if (error.code === 'ECONNABORTED') {
            mensaje = 'La importación superó el tiempo máximo permitido. Intente nuevamente o reduzca la cantidad de registros.'
          } else if (error.response && error.response.status === 405) {
            mensaje = 'El servicio de importación no tiene habilitado el método requerido.'
          } else if (
            error.response &&
            error.response.data &&
            (error.response.data.ResultError || error.response.data.message)
          ) {
            mensaje = error.response.data.ResultError || error.response.data.message
          }

          this.importProgress = false
          this.importResultType = 'error'
          this.importResultTitle = error.code === 'ECONNABORTED'
            ? 'Tiempo de espera agotado'
            : 'Error en la importación'
          this.importResultMessage = mensaje
          this.importResultVisible = true
        })
        .finally(() => {
          if (!this.importProgressComplete) {
            this.importProgress = false
          }

          event.target.value = ''
        })
      },

      
    }
  }
  </script>
  
  <style scoped>
  .custom-header {
    background-color: #1976d2; /* Azul Vuetify */
    color: white;
    font-weight: bold;
    text-transform: uppercase;
  }
  .tab-active {
  color: red !important;
  }
  .tab-inactive {
    color: black !important;
  }
  .button-group {
  gap: 16px;
}
  </style>


// WEBPACK FOOTER //
// src/components/Penalities.vue